<template>
    <BreadCrumb PageTitle="Ajouter un type de cargaison" />
    <AddModalTypeCargaison/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddModalTypeCargaison from "@/components/TypeCargaison/AddModalTypeCargaison.vue";
  
    export default defineComponent({
      name: "AddTypeCargaisonPage",
      components: {
        BreadCrumb,
        AddModalTypeCargaison,
      },
    });
  </script>